import type { Strings } from "./zh.js";

// English strings for Trenz brand
export const en: Strings = {
  hero: {
    badge: "Trenz Open Platform",
    titleLine1: "One-stop API platform",
    titleLine2: "for social commerce",
    desc: "TikTok commerce data · AI content · social publishing · ads — four pillars, one API key.",
    ctaPrimary: "Quick Start in 5 minutes",
    ctaSecondary: "Apply for API Key",
    capabilityTags: {
      ecommerce: "Commerce Data",
      aiVideo: "AI Video",
      social: "Social",
      ads: "Ads",
    },
    stats: {
      tiktokValue: "TikTok-wide",
      tiktokLabel: "Products · Creators · Videos · Ads · Lives",
      seedanceValue: "Seedance 2.0",
      seedanceLabel: "Leading AI video model",
      multiPlatformValue: "Multi-platform",
      multiPlatformLabel: "Accounts · Publishing · Engagement · Analytics",
    },
    statsRow: {
      col1Value: "50M+",
      col1Label: "TikTok products",
      col2Value: "2M+",
      col2Label: "Creators indexed",
      col3Value: "~60s avg",
      col3Label: "Video generation",
    },
  },

  featureGrid: {
    ecommerce: {
      title: "TikTok Commerce Data",
      desc: "Multi-dimensional search and detail lookup across products, shops, creators, videos, ads and live streams, with 30+ sort and filter options.",
      tags: ["Product Search", "Creator Discovery", "Trending Videos", "Live Data"],
    },
    aiContent: {
      title: "AI Content Generation",
      desc: "End-to-end AI capabilities: video generation (Seedance 2.0 / Sora2 / Veo3 / Wan2.6), image generation, copywriting, video analysis, and speech-to-text.",
      tags: ["Video Gen", "Image Gen", "Copywriting", "Transcription"],
    },
    social: {
      title: "Social Media Management",
      desc: "Multi-platform account management, content publishing, comment engagement, analytics, and scheduling — the full social ops workflow as APIs.",
      tags: ["Multi-account", "Publishing", "Engagement", "Analytics"],
    },
    ads: {
      title: "Ads & Marketing",
      desc: "TikTok ad account management, performance insights, landing-page management, and lead capture — from campaign launch to conversion.",
      tags: ["Account Ops", "Insights", "Landing Pages", "Lead Capture"],
    },
  },

  quickStart: {
    eyebrow: "Quick Start",
    heading: "One curl call, see your first result",
    copy: "Copy",
    copied: "Copied",
    noApiKey: "Don't have an API key yet?",
    applyLink: "Apply for trial →",
  },

  endpointShowcase: {
    eyebrow: "Featured Endpoints",
    heading: "Start from these endpoints",
    productsSearchDesc: "Search TikTok products by keyword, country, and sort by sales",
    creatorsSearchDesc: "Discover TikTok commerce creators by category and country",
    sdProVideoDesc: "Submit text-to-video jobs (Seedance 2.0 / Sora2 / Veo3)",
    socialAccountsDesc: "Unified management and listing of multi-platform social accounts",
  },

  siteHomeLink: {
    label: "Trenz Home",
  },

  sidebarHomeLink: {
    back: "Back",
  },
};
